// src/components/private/users/UserAccount.js
// Component to enable a user to select an option to see information about their account

import React from 'react';
import ViewUserAccount from './ViewUserAccount';
import ViewUserHouseholds from './ViewUserHouseholds';
import OptionSelector from '../common_components/OptionSelector';
import UserFavoriteStores from '../highgarden/favorites/UserFavoriteStores';

const options = [
    {
        icon: "bi bi-person-circle",
        label: "My Account",
        value: "userAccount",
        component: ViewUserAccount
    },
    {
        icon: "bi bi-people-fill",
        label: "My Households",
        value: "userHouseholds",
        component: ViewUserHouseholds
    },
    {
        icon: "bi bi-shop",
        label: "Favorite Stores",
        value: "userFavoriteStores",
        component: UserFavoriteStores
    }

];

const UserAccount = () => {
    return (
        <OptionSelector
            options={options}
            initialOption="userAccount"
        />
    )
};

export default UserAccount;